/* eslint-disable */
export default {
  title: '地区',
  NAOnlyMessage: '请设置您的区号。此信息将用于本地拨号。',
  MultiWithNAMessage:
    '请为您的地区设置国家代码和区号。此信息将用于本地拨号和电话号码格式。',
  MultiWithoutNAMessage:
    '请选择您所在的国家/地区。此信息将用于本地拨号和电话号码格式设置。',
  country: '国家/地区',
  areaCode: '区号',
  areaCodePlaceholder: '输入区号',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
